import { useToggle } from "hooks/useToggle";
import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { ModalV2 } from "components/Modal/ModalV2";
import { useForm } from "hooks/useForm";
import {
  editMovementToPolicyAction,
  deleteMovementToPolicyAction,
} from "redux/actions/policyManagment/policyManagmentActions";
import { useDispatch, useSelector } from "react-redux";
import { PolicyMovForm } from "./PolicyMovForm";
import { ActionsButtons } from "components/CustomButtons/ActionsButtons";
import { PERMISSIONS } from "router/permissions";
import { useRuleValidator } from "hooks/useRuleValidator";
import { validateObject } from "helpers/validateObject";
import { formatNumber } from "helpers/getNumberFormats";
export const columns = [
  {
    Header: "Numero CT",
    accessor: "number",
    filterable: true,
    sortable: true,
    filterMethod: (filter, row) => {
      return row.number.toLowerCase().includes(filter.value.toLowerCase());
    },
  },
  {
    Header: "Cuenta contable",
    accessor: "name",
    filterable: true,
    sortable: true,
    filterMethod: (filter, row) => {
      return row.name.toLowerCase().includes(filter.value.toLowerCase());
    },
  },
  {
    Header: "Cargo $",
    accessor: "charge",
    filterable: true,
    sortable: true,
    Cell: ({ value }) => {
      return value !== null && value !== undefined
        ? formatNumber({ input: value }, "$", true)
        : "";
    },
    filterMethod: (filter, row) => {
      if (row.charge === null || row.charge === undefined) return false;
      return row.charge
        .toString()
        .toLowerCase()
        .includes(filter.value.toLowerCase());
    },
  },
  {
    Header: "Abono $",
    accessor: "payment",
    filterable: true,
    sortable: true,
    Cell: ({ value }) => {
      return value !== null && value !== undefined
        ? formatNumber({ input: value }, "$", true)
        : "";
    },
    filterMethod: (filter, row) => {
      if (row.payment === null || row.payment === undefined) return false;
      return row.payment
        .toString()
        .toLowerCase()
        .includes(filter.value.toLowerCase());
    },
  },
  {
    Header: "Concepto",
    accessor: "concept",
    filterable: true,
    sortable: true,
    filterMethod: (filter, row) => {
      return row.concept.toLowerCase().includes(filter.value.toLowerCase());
    },
  },
  {
    Header: "Acciones",
    Cell: ({ original }) => {
      const dispatch = useDispatch();
      const { policy } = useSelector(({ policyManagment }) => policyManagment);
      const [open, setOpen] = useToggle();
      const [openDelete, setOpenDelete] = useToggle();
      const { values, onChange } = useForm({ concept: original.concept || "" });
      const { isLoadingComp } = useSelector(({ search }) => search);
      const { POLICY_CREATE_EDIT, POLICY_DELETE } = PERMISSIONS;
      const canEdit = useRuleValidator(POLICY_CREATE_EDIT);
      const canDelete = useRuleValidator(POLICY_DELETE);
      const handleEditSubmit = () => {
        dispatch(editMovementToPolicyAction(original.id, values, setOpen));
      };

      const handleDeleteSubmit = () => {
        dispatch(
          deleteMovementToPolicyAction(original.id, null, setOpenDelete)
        );
      };
      const buttons = [
        {
          label: "Eliminar",
          onClick: setOpenDelete,
          color: 3,
          Icon: DeleteIcon,
          validation: canDelete,
        },
        {
          label: "Editar",
          onClick: setOpen,
          color: 0,
          Icon: EditIcon,
          validation: canEdit,
        },
      ];
      return (
        <>
          {validateObject(policy) && policy.status === "CREATE" && (
            <ActionsButtons buttons={buttons} />
          )}
          <ModalV2
            open={open}
            onClose={setOpen}
            title={`Editar movimiento (${original.number} - ${original.name})`}
            onSubmit={handleEditSubmit}
            loading={isLoadingComp?.editMovementToPolicy}
            justConfirm
          >
            <PolicyMovForm
              edit
              values={values}
              original={original}
              onChange={onChange}
            />
          </ModalV2>
          <ModalV2
            open={openDelete}
            onClose={setOpenDelete}
            title={`Eliminar movimiento (${original.number} - ${original.name})`}
            justConfirm
            onSubmit={handleDeleteSubmit}
            loading={isLoadingComp?.deleteMovementToPolicy}
          />
        </>
      );
    },
  },
];
